import user from './user';
import { ROUTES } from 'dictionary/routes';

export default function logoutUser() {
  user.logout();
  window.location = ROUTES.ROOT;
  return;
}
